import React from 'react'
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';

const BillingAddressPreview = ({
  billingInfo, 
  setDisplayBillingForm
}) => {
  
  return (
    <Grid 
      container 
      item 
      justifyContent="space-between" 
    >
      <Grid item>
        <Typography variant="body1" gutterBottom>
          {billingInfo?.line1} {billingInfo?.line2}
        </Typography >
        <Typography variant="body2" gutterBottom>
          {billingInfo?.city}, {billingInfo?.state} {billingInfo?.postal_code}
        </Typography>
        <Typography variant="subtitle2" gutterBottom>
          {billingInfo?.country}
        </Typography>
      </Grid>

      <Grid component={Box} item alignSelf='center' >
        <Button 
          onClick={() => setDisplayBillingForm(true)} 
          variant="contained" 
          color="primary"
        >
          Edit
        </Button>
      </Grid>
    </Grid>
  )
}

export default BillingAddressPreview